import styled, { css } from 'styled-components';

import PropTypes from 'prop-types';

const baseButton = css`
  background: ${({ backgroundColor }) => backgroundColor || 'transparent'};
  border: none;
  font-size: ${({ size }) => size || '30px'};
  cursor: pointer;
  color: ${({ color }) => color || '#dedede'};
  padding: 0;
  line-height: 1.5;
  letter-spacing: normal;

  &:hover {
    color: ${({ hoverColor }) => hoverColor || '#fff'};
  }
`;

// Variants for layout/appearance differences
const variantStyles = {
  default: css`
    position: absolute;
    right: 10px;
    top: 2px;
  `,
  bordered: css`
    position: relative;
    margin-left: auto;
    border: 1px solid ${({ borderColor }) => borderColor || '#dedede'};
    background: ${({ backgroundColor }) => backgroundColor || '#ced4d7ff'};
    border-radius: 32px;
    padding: 0px 2px 0px 2px;
    top: 10px;
    right: 10px;
    font-size: ${({ size }) => size || '32px'};
    line-height: 28px;
    height: 30px;
    width: 30px;
    color: ${({ color }) => color || '#888'};
  `,
};

const StyledCloseButton = styled.button`
  ${baseButton}
  ${({ variant }) => variantStyles[variant] || variantStyles.default}
`;

const CloseButton = ({
  onClick,
  variant,
  size,
  color,
  hoverColor,
  backgroundColor,
  borderColor,
  children,
}) => (
  <StyledCloseButton
    onClick={onClick}
    variant={variant}
    size={size}
    color={color}
    hoverColor={hoverColor}
    backgroundColor={backgroundColor}
    borderColor={borderColor}
    aria-label="Close">
    {children || '\u00D7'}
  </StyledCloseButton>
);

CloseButton.propTypes = {
  onClick: PropTypes.func.isRequired,
  variant: PropTypes.oneOf(['default', 'bordered']),
  size: PropTypes.string,
  color: PropTypes.string,
  hoverColor: PropTypes.string,
  backgroundColor: PropTypes.string,
  borderColor: PropTypes.string,
  children: PropTypes.node,
};

CloseButton.defaultProps = {
  variant: 'default',
  size: '30px',
  color: '#dedede',
  hoverColor: '#fff',
  backgroundColor: 'transparent',
  borderColor: '#dedede',
  children: null,
};
export default CloseButton;
